import React from 'react';
import './PricingDescription.css';

const PricingDescription = ({ title, subtitle }) => {
  return (
    <div className='tarif_head_automatic_files'>
      <div className="pricing-description">
        <h1 className="pricing-title">{title}</h1>
        <p className="pricing-subtitle">{subtitle}</p>
      </div>
    </div>
  );
}; 

PricingDescription.defaultProps = {
  title: 'Comparez nos plans',
  subtitle: 'Choisissez votre espace de travail en fonction de votre organisation.'
};

export default PricingDescription;

